// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"869b4f3c","159":"5f07eac6","333":"e71c6c9a","404":"b797a448","530":"0135ec1c","910":"9a510810"}[chunkId] + ".chunk.js";
};